export function useOnClickLegendItem(chartRef) {
  return (datasetIndex, isVisible) => {
    chartRef.value.chart.setDatasetVisibility(datasetIndex, isVisible)
    chartRef.value.chart.update()
  }
}
